"use client";

import { Icon } from "@iconify/react";
import Image from "next/image";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const BillCategories = ({ data }) => {
  const bgColors = [
    "bg-[#E5F9D1]",
    "bg-[#FDECEC]",
    "bg-[#EEF4FF]",
    "bg-[#FFF6E9]",
    "bg-[#EAF7F5]",
    "bg-[#F3EEFF]",
  ];
  return (
    <div className="section_space_py">
      <h2 className="title-design text-center title_mb">Bill Categories</h2>

      <div className="custom-container mx-auto relative overflow-hidden">
        {/* Custom Navigation */}
        <button className="bill-prev absolute left-0 top-1/2 -translate-y-1/2 z-10">
          <div className="bill-swiper-btn w-[30px] h-[30px] flex items-center justify-center bg-white rounded-full border border-[rgba(45,45,45,0.10)] shadow">
            <Icon icon="basil:caret-left-solid" width="24" height="24" />
          </div>
        </button>

        <button className="bill-next absolute right-0 top-1/2 -translate-y-1/2 z-10">
          <div className="bill-swiper-btn w-[30px] h-[30px] flex items-center justify-center bg-white rounded-full border border-[rgba(45,45,45,0.10)] shadow">
            <Icon icon="basil:caret-right-outline" width="24" height="24" />
          </div>
        </button>

        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          navigation={{
            prevEl: ".bill-prev",
            nextEl: ".bill-next",
          }}
          className="bill-categories-swiper !pr-0"
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            567: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          }}
          modules={[Navigation]}
        >
          {data?.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`flex items-center gap-6 p-5 rounded-[12px] w-full ${
                  bgColors[index % bgColors.length]
                }`}
              >
                <div className="w-[36px] h-[36px] shrink-0">
                  <Image
                    src={item?.icon}
                    alt={item?.title}
                    width={36}
                    height={36}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div>
                  <h4 className="text-[18px] font-bold text-user-text mb-1.5">
                    {item?.title}
                  </h4>
                  <p className="text-[14px] font-medium text-user-paragraph">
                    {item?.description}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default BillCategories;
